import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { IMapControllerInitialState } from "./types";

const setMapZoom: CaseReducer<IMapControllerInitialState, PayloadAction<IMapControllerInitialState['zoom']>> = (state, action) => {
  state.zoom = action.payload;
};

const setMapType: CaseReducer<IMapControllerInitialState, PayloadAction<IMapControllerInitialState['type']>> = (state, action) => {
  state.type = action.payload;
};

const setMapCenter: CaseReducer<IMapControllerInitialState, PayloadAction<IMapControllerInitialState['center']>> = (state, action) => {
  state.center = action.payload;
};

const setMapLocation: CaseReducer<IMapControllerInitialState, PayloadAction<IMapControllerInitialState['location']>> = (state, action) => {
  state.location = action.payload;

  const lat = Number(action?.payload?.latitude);
  const lng = Number(action?.payload?.longitude);

  if (isNaN(lat) || isNaN(lng)) return;

  state.center = { lat, lng };
};

const resetMapLocation: CaseReducer<IMapControllerInitialState, PayloadAction> = (state) => {
  state.location = undefined;
};

type RulerPoint = google.maps.LatLngLiteral;
type RulerPointAt = { index: number; point: RulerPoint };

const setRulerActive: CaseReducer<IMapControllerInitialState, PayloadAction<boolean>> = (state, action) => {
  state.rulerActive = action.payload;
  if (!action.payload) state.rulerPoints = [];
};

const addRulerPoint: CaseReducer<IMapControllerInitialState, PayloadAction<RulerPoint>> = (state, action) => {
  state.rulerPoints.push(action.payload);
};

const updateRulerPoint: CaseReducer<IMapControllerInitialState, PayloadAction<RulerPointAt>> = (state, action) => {
  const { index, point } = action.payload;
  if (index < 0 || index >= state.rulerPoints.length) return;
  state.rulerPoints[index] = point;
};

const insertRulerPoint: CaseReducer<IMapControllerInitialState, PayloadAction<RulerPointAt>> = (state, action) => {
  const { index, point } = action.payload;
  state.rulerPoints.splice(Math.max(0, Math.min(index, state.rulerPoints.length)), 0, point);
};

const removeRulerPoint: CaseReducer<IMapControllerInitialState, PayloadAction<number>> = (state, action) => {
  if (action.payload < 0 || action.payload >= state.rulerPoints.length) return;
  state.rulerPoints.splice(action.payload, 1);
};

const clearRulerPoints: CaseReducer<IMapControllerInitialState, PayloadAction> = (state) => {
  state.rulerPoints = [];
};

export default {
  setMapZoom,
  setMapType,
  setMapCenter,
  setMapLocation,
  resetMapLocation,
  setRulerActive,
  addRulerPoint,
  updateRulerPoint,
  insertRulerPoint,
  removeRulerPoint,
  clearRulerPoints,
};